import { useTranslation } from 'react-i18next'

import { useMutation } from 'components/graphql'
import { ConfirmModal } from 'components/Modal'

export default ({ sectionData, history, baseUrl, subsectionData }) => {
	const delMutation = sectionData?.deleteMutation
	const [mutate] = useMutation(delMutation, {
		onCompleted: () => history.push(`/${baseUrl}/${sectionData?.link}/${subsectionData?.link}`)
	})
	const [t] = useTranslation()

	const handler = id => {
		if(!delMutation) {
			return
		}
		const callDelMutation = () => {
			mutate({
				variables: { id }
			})
		}

		ConfirmModal({
			text: t('common.strings.sure_delete'),
			label: t('common.strings.delete_data')
		}).then(
			confirmed => callDelMutation()
		).catch(e => {})
	}
	return handler
}
